"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const doubleOptInRedirectInputs = [
  {
    name: "successPageRedirectUrl",
    type: "string",
    required: true,
    defaultValue: "",
  },
  {
    name: "errorPageRedirectUrl",
    type: "string",
    required: true,
    defaultValue: "",
  },
] as const satisfies Inputs;

export const DoubleOptInRedirectComponent: RegisteredComponent = {
  name: "DoubleOptInRedirect",
  component: dynamic(async () =>
    withValidation(
      doubleOptInRedirectInputs,
      (await import("./DoubleOptInRedirect")).DoubleOptInRedirect,
      "DoubleOptInRedirect"
    )
  ),
  inputs: doubleOptInRedirectInputs,
};
